import $axios from '@/libs/OAuth2/services/axios.js';
import md5 from 'md5';
import { router as $router } from '@/libs/Router/router.js';

const emailToMd5 = email => md5(email.toString().toLowerCase());
const forecast = () => {
  return {
    forecast: $router?.currentRoute?.query?.forecast || undefined,
  };
};

export default {
  getStatus: () => $axios.get('/status'),
  deleteCompanyUser: (companyId, userId) => $axios.delete(`/companies/${companyId}/users/${userId}`),
  deleteUserReservation: reservationId => $axios.delete(`/users/reservation/${reservationId}`),
  reserveUser: reservedUser => $axios.post('/users/reservation', reservedUser),
  getUserReservation: (email, token) => $axios.get(`/users/${email}/reservation/${token}`),
  registerUser: (email, token, user) => {
    let body = {};
    if (user?.name && user?.surname && user?.password) {
      body = user;
    }

    return $axios.post(`/users/${email}/reservation/${token}`, body);
  },
  declinesRegisterUser: (email, token) => $axios.delete(`/users/${email}/reservation/${token}`),

  // Change password
  getChangePasswordToken: email => $axios.post(`/users/${emailToMd5(email)}/changePasswordTokens`),
  changePasswordWithToken: (email, token, password) => $axios.post(`/users/${email}/password`, { token, password }),

  // My profile
  getMyProfile: () => $axios.get('/profile'),
  updateMyProfile: user => $axios.put('/profile', user),
  updateProfile: user => $axios.put(`/profile/${user.id}`, user),
  changeMyPassword: (password, newPassword) => $axios.post('/profile/password', { password, newPassword }),
  getUserProfile: id => $axios.get(`/users/${id}`),

  // Contact us
  contactUs: contactUsRequest => $axios.post('/contactUsMessages', contactUsRequest),

  // Companies
  createCompany: company => $axios.post('/companies', company),
  companies: (params) => $axios.get('/companies', { params: params }),
  company: id => $axios.get(`/companies/${id}`, { params: { ...forecast() } }),
  companyUsers: id => $axios.get(`/companies/${id}/users`),
  disableCompany: (id, from) => $axios.patch(`/companies/${id}/disable`, { from }),
  enableCompany: id => $axios.patch(`/companies/${id}/enable`, {}),
  updateCompany: (id, body) => $axios.put(`/companies/${id}`, body),
  // Companies for investors
  enableForInvestors: id => $axios.patch(`/companies/${id}/enable-for-investors`, {}),
  disableForInvestors: id => $axios.patch(`/companies/${id}/disable-for-investors`, {}),
  // Companies dashboards
  getDashboardConfig: idCompany => $axios.get(`/companies/${idCompany}/dashboard`),
  setDashboardConfig: (idCompany, payload) => $axios.put(`/companies/${idCompany}/dashboard`, payload),
  activateCompany: (id, year, month, balance = null) => $axios.post(`/companies/${id}/activate`, {
    year,
    month,
    balance,
  }),

  // Modules
  listModules: () => $axios.get('/modules'),
  enableModuleForCompany: (idCompany, moduleCode) => $axios.post(`/companies/${idCompany}/modules/${moduleCode}`),
  disableModuleForCompany: (idCompany, moduleCode) => $axios.delete(`/companies/${idCompany}/modules/${moduleCode}`),

  // Consultants
  consultants: (all = false) => $axios.get('/consultants' + (all ? '?all=true' : '')),
  consultant: id => $axios.get(`/consultants/${id}`),
  disableConsultant: id => $axios.patch(`/consultants/${id}/disable`, {}),
  enableConsultant: id => $axios.patch(`/consultants/${id}/enable`, {}),

  // Investors
  investors: (all = false) => $axios.get('/investors' + (all ? '?all=true' : '')),
  investor: id => $axios.get(`/investors/${id}`),
  disableInvestor: id => $axios.patch(`/investors/${id}/disable`, {}),
  enableInvestor: id => $axios.patch(`/investors/${id}/enable`, {}),

  /*
   * FORECASTS
   */
  // Forecasts
  createForecast: (idCompany, payload) => $axios.post(`/companies/${idCompany}/forecasts`, payload),
  getForecasts: idCompany => $axios.get(`/companies/${idCompany}/forecasts`),
  getForecast: (idCompany, idForecast) => $axios.get(`/companies/${idCompany}/forecasts/${idForecast}`),
  updateForecast: (idCompany, idForecast, body) => $axios.put(`/companies/${idCompany}/forecasts/${idForecast}`, body),
  deleteForecast: (idCompany, idForecast) => $axios.delete(`/companies/${idCompany}/forecasts/${idForecast}`),

  // Dashboard
  getForecastDashboard: (idCompany, year = null) => $axios.get(`/companies/${idCompany}/forecasts/dashboard`, { params: { year, ...forecast() } }),

  // Activation
  getSettings: id => $axios.get(`/companies/${id}/forecasts/settings`, { params: { ...forecast() } }),
  saveSettings: (id, settings) => $axios.post(`/companies/${id}/forecasts/settings`, settings, { params: { ...forecast() } }),

  // Module Projects
  listProjectLibraryCosts: idCompany => $axios.get(`/companies/${idCompany}/projectLibraryCosts`, { params: { all: true } }),
  addProjectLibraryCost: (idCompany, cost) => $axios.post(`/companies/${idCompany}/projectLibraryCosts`, cost),
  getProjectLibraryCost: (_, idCost) => $axios.get(`/projectLibraryCosts/${idCost}`),
  updateProjectLibraryCost: (_, idCost, cost) => $axios.put(`/projectLibraryCosts/${idCost}`, cost),
  deleteProjectLibraryCost: (_, idCost) => $axios.delete(`/projectLibraryCosts/${idCost}`),

  listImputedCosts: idCompany => $axios.get(`/companies/${idCompany}/imputedCosts`, { params: { all: true } }),
  addImputedCost: (idCompany, cost) => $axios.post(`/companies/${idCompany}/imputedCosts`, cost),
  getImputedCost: (_, idCost) => $axios.get(`/imputedCosts/${idCost}`),
  updateImputedCost: (_, idCost, cost) => $axios.put(`/imputedCosts/${idCost}`, cost),
  deleteImputedCost: (_, idCost) => $axios.delete(`/imputedCosts/${idCost}`),

  listProjectLibraryTemplates: (idCompany, complete = false) => $axios.get(`/companies/${idCompany}/projectLibraryTemplates`, { params: { all: true, complete } }),
  addProjectLibraryTemplate: (idCompany, template) => $axios.post(`/companies/${idCompany}/projectLibraryTemplates`, template),
  getProjectLibraryTemplate: (_, idTemplate) => $axios.get(`/projectLibraryTemplates/${idTemplate}`),
  updateProjectLibraryTemplate: (_, idTemplate, template) => $axios.put(`/projectLibraryTemplates/${idTemplate}`, template),
  deleteProjectLibraryTemplate: (_, idTemplate) => $axios.delete(`/projectLibraryTemplates/${idTemplate}`),

  getComputedProjects: idCompany => $axios.get(`/companies/${idCompany}/forecasts/computed/projects`, { params: { ...forecast() } }),
  getComputedProject: (idCompany, idProject) => $axios.get(`/companies/${idCompany}/forecasts/computed/projects/${idProject}`, { params: { ...forecast() } }),
  listProjects: (idCompany, statuses) => {
    const params = {
      all: true,
      ...forecast(),
    };

    statuses = statuses || {
      budgeted: true,
      accepted: true,
      started: true,
      completed: true,
    };

    Object.keys(statuses).map(key => {
      const completeKey = `status[${key}]`;
      Object.assign(params, { [completeKey]: statuses[key] });
    });

    return $axios.get(`/companies/${idCompany}/forecasts/projects`, {
      params,
    });
  },
  addProject: (idCompany, project) => $axios.post(`/companies/${idCompany}/forecasts/projects`, project, { params: { ...forecast() } }),
  getProject: (_, idProject) => $axios.get(`/forecasts/projects/${idProject}`, { params: { ...forecast() } }),
  updateProject: (_, idProject, project) => $axios.put(`/forecasts/projects/${idProject}`, project, { params: { ...forecast() } }),
  acceptProject: (_, idProject) => $axios.post(`/forecasts/projects/${idProject}/accepted`, {}, { params: { ...forecast() } }),
  deleteProject: (_, idProject) => $axios.delete(`/forecasts/projects/${idProject}`, { params: { ...forecast() } }),

  getProjectDashboard: idCompany => $axios.get(`/companies/${idCompany}/forecasts/dashboard`, { params: { ...forecast() } }),
  // getProjectDashboard: idCompany => $axios.get(`/companies/${idCompany}/forecasts/projects/dashboard`, { params: { ...forecast() } }),

  // Ricavi
  getComputedRicavi: idCompany => $axios.get(`/companies/${idCompany}/forecasts/computed/ricavi`, { params: { ...forecast() } }),
  getRicavi: idCompany => $axios.get(`/companies/${idCompany}/forecasts/ricavi`, { params: { ...forecast() } }),
  listRicavi: idCompany => $axios.get(`/companies/${idCompany}/forecasts/ricavi`, { params: { all: true, ...forecast() } }),
  addRicavo: (idCompany, ricavo) => $axios.post(`/companies/${idCompany}/forecasts/ricavi`, ricavo, { params: { ...forecast() } }),
  getRicavo: (_, idRicavo) => $axios.get(`/forecasts/ricavi/${idRicavo}`, { params: { ...forecast() } }),
  updateRicavo: (_, idRicavo, ricavo) => $axios.put(`/forecasts/ricavi/${idRicavo}`, ricavo, { params: { ...forecast() } }),
  deleteRicavo: (_, idRicavo) => $axios.delete(`/forecasts/ricavi/${idRicavo}`, { params: { ...forecast() } }),
  saveRicavoValue: (_, idRicavo, type, year, month, value) => $axios.post(`/forecasts/ricavi/${idRicavo}/values`, {
    type,
    year,
    month,
    value,
  }, { params: { ...forecast() } }),

  // Costi Cogs
  getComputedCostiCogs: idCompany => $axios.get(`/companies/${idCompany}/forecasts/computed/costi-cogs`, { params: { ...forecast() } }),
  getCostiCogs: idCompany => $axios.get(`/companies/${idCompany}/forecasts/costi-cogs`, { params: { ...forecast() } }),
  addCostoCogs: (idCompany, costoCogs) => $axios.post(`/companies/${idCompany}/forecasts/costi-cogs`, costoCogs, { params: { ...forecast() } }),
  getCostoCogs: (_, idCostoCogs) => $axios.get(`/forecasts/costi-cogs/${idCostoCogs}`, { params: { ...forecast() } }),
  updateCostoCogs: (_, idCostoCogs, costoCogs) => $axios.put(`/forecasts/costi-cogs/${idCostoCogs}`, costoCogs, { params: { ...forecast() } }),
  deleteCostoCogs: (_, idCostoCogs) => $axios.delete(`/forecasts/costi-cogs/${idCostoCogs}`, { params: { ...forecast() } }),
  saveCostoCogsValue: (_, idCostoCogs, type, year, month, value) => $axios.post(`/forecasts/costi-cogs/${idCostoCogs}/values`, {
    type,
    year,
    month,
    value,
  }, { params: { ...forecast() } }),

  // Costi G&A
  getComputedCostiGA: idCompany => $axios.get(`/companies/${idCompany}/forecasts/computed/costi-GA`, { params: { ...forecast() } }),
  getCostiGA: idCompany => $axios.get(`/companies/${idCompany}/forecasts/costi-GA`, { params: { ...forecast() } }),
  addCostoGA: (idCompany, costoGa) => $axios.post(`/companies/${idCompany}/forecasts/costi-GA`, costoGa, { params: { ...forecast() } }),
  getCostoGA: (_, idCostoGa) => $axios.get(`/forecasts/costi-GA/${idCostoGa}`, { params: { ...forecast() } }),
  updateCostoGA: (_, idCostoGa, costoGa) => $axios.put(`/forecasts/costi-GA/${idCostoGa}`, costoGa, { params: { ...forecast() } }),
  deleteCostoGA: (_, idCostoGa) => $axios.delete(`/forecasts/costi-GA/${idCostoGa}`, { params: { ...forecast() } }),
  saveCostoGAValue: (_, idCostoGa, type, year, month, value) => $axios.post(`/forecasts/costi-GA/${idCostoGa}/values`, {
    type,
    year,
    month,
    value,
  }, { params: { ...forecast() } }),

  // Costi Personale
  getComputedCostiPersonale: idCompany => $axios.get(`/companies/${idCompany}/forecasts/computed/costi-personale`, { params: { ...forecast() } }),
  getCostiPersonale: idCompany => $axios.get(`/companies/${idCompany}/forecasts/costi-personale`, { params: { ...forecast() } }),
  addCostoPersonale: (idCompany, costoPersonale) => $axios.post(`/companies/${idCompany}/forecasts/costi-personale`, costoPersonale, { params: { ...forecast() } }),
  getCostoPersonale: (_, idCostoPersonale) => $axios.get(`/forecasts/costi-personale/${idCostoPersonale}`, { params: { ...forecast() } }),
  updateCostoPersonale: (_, idCostoPersonale, costoPersonale) => $axios.put(`/forecasts/costi-personale/${idCostoPersonale}`, costoPersonale, { params: { ...forecast() } }),
  deleteCostoPersonale: (_, idCostoPersonale) => $axios.delete(`/forecasts/costi-personale/${idCostoPersonale}`, { params: { ...forecast() } }),
  saveCostoPersonaleValue: (_, idCostoPersonale, type, year, month, value) => $axios.post(`/forecasts/costi-personale/${idCostoPersonale}/values`, {
    type,
    year,
    month,
    value,
  }, { params: { ...forecast() } }),

  // Equities
  getComputedEquities: idCompany => $axios.get(`/companies/${idCompany}/forecasts/computed/equities`, { params: { ...forecast() } }),
  getEquities: idCompany => $axios.get(`/companies/${idCompany}/forecasts/equities`, { params: { ...forecast() } }),
  addEquity: (idCompany, equity) => $axios.post(`/companies/${idCompany}/forecasts/equities`, equity, { params: { ...forecast() } }),
  getEquity: (_, idEquity) => $axios.get(`/forecasts/equities/${idEquity}`, { params: { ...forecast() } }),
  updateEquity: (_, idEquity, equity) => $axios.put(`/forecasts/equities/${idEquity}`, equity, { params: { ...forecast() } }),
  deleteEquity: (_, idEquity) => $axios.delete(`/forecasts/equities/${idEquity}`, { params: { ...forecast() } }),
  saveEquityValue: (idCompany, type, year, month, value) => $axios.post(`/companies/${idCompany}/forecasts/equities/values`, {
    type,
    year,
    month,
    value,
  }, { params: { ...forecast() } }),

  // Investimenti
  getComputedInvestimenti: idCompany => $axios.get(`/companies/${idCompany}/forecasts/computed/investimenti`, { params: { ...forecast() } }),
  getInvestimenti: idCompany => $axios.get(`/companies/${idCompany}/forecasts/investimenti`, { params: { ...forecast() } }),
  addInvestimento: (idCompany, investimento) => $axios.post(`/companies/${idCompany}/forecasts/investimenti`, investimento, { params: { ...forecast() } }),
  getInvestimento: (_, idInvestimento) => $axios.get(`/forecasts/investimenti/${idInvestimento}`, { params: { ...forecast() } }),
  updateInvestimento: (_, idInvestimento, investimento) => $axios.put(`/forecasts/investimenti/${idInvestimento}`, investimento, { params: { ...forecast() } }),
  deleteInvestimento: (_, idInvestimento) => $axios.delete(`/forecasts/investimenti/${idInvestimento}`, { params: { ...forecast() } }),

  // Finanziamenti
  getComputedFinanziamenti: idCompany => $axios.get(`/companies/${idCompany}/forecasts/computed/finanziamenti`, { params: { ...forecast() } }),
  getFinanziamenti: idCompany => $axios.get(`/companies/${idCompany}/forecasts/finanziamenti`, { params: { ...forecast() } }),
  addFinanziamento: (idCompany, finanziamento) => $axios.post(`/companies/${idCompany}/forecasts/finanziamenti`, finanziamento, { params: { ...forecast() } }),
  getFinanziamento: (_, idFinanziamento) => $axios.get(`/forecasts/finanziamenti/${idFinanziamento}`, { params: { ...forecast() } }),
  updateFinanziamento: (_, idFinanziamento, finanziamento) => $axios.put(`/forecasts/finanziamenti/${idFinanziamento}`, finanziamento, { params: { ...forecast() } }),
  deleteFinanziamento: (_, idFinanziamento) => $axios.delete(`/forecasts/finanziamenti/${idFinanziamento}`, { params: { ...forecast() } }),

  // ContributiFondoPerduto
  getComputedContributiFondoPerduto: idCompany => $axios.get(`/companies/${idCompany}/forecasts/computed/contributi-fondo-perduto`, { params: { ...forecast() } }),
  getContributiFondoPerduto: idCompany => $axios.get(`/companies/${idCompany}/forecasts/contributi-fondo-perduto`, { params: { ...forecast() } }),
  addContributoFondoPerduto: (idCompany, contributoFondoPerduto) => $axios.post(`/companies/${idCompany}/forecasts/contributi-fondo-perduto`, contributoFondoPerduto, { params: { ...forecast() } }),
  getContributoFondoPerduto: (_, idContributoFondoPerduto) => $axios.get(`/forecasts/contributi-fondo-perduto/${idContributoFondoPerduto}`, { params: { ...forecast() } }),
  updateContributoFondoPerduto: (_, idContributoFondoPerduto, contributoFondoPerduto) => $axios.put(`/forecasts/contributi-fondo-perduto/${idContributoFondoPerduto}`, contributoFondoPerduto, { params: { ...forecast() } }),
  deleteContributoFondoPerduto: (_, idContributoFondoPerduto) => $axios.delete(`/forecasts/contributi-fondo-perduto/${idContributoFondoPerduto}`, { params: { ...forecast() } }),

  // Crediti d'imposta
  getCreditiImposta: idCompany => $axios.get(`/companies/${idCompany}/forecasts/crediti-imposta`, { params: { ...forecast() } }),
  addCreditoImposta: (idCompany, creditoImposta) => $axios.post(`/companies/${idCompany}/forecasts/crediti-imposta`, creditoImposta, { params: { ...forecast() } }),
  getCreditoImposta: (_, idCreditoImposta) => $axios.get(`/forecasts/crediti-imposta/${idCreditoImposta}`, { params: { ...forecast() } }),
  updateCreditoImposta: (_, idCreditoImposta, creditoImposta) => $axios.put(`/forecasts/crediti-imposta/${idCreditoImposta}`, creditoImposta, { params: { ...forecast() } }),
  deleteCreditoImposta: (_, idCreditoImposta) => $axios.delete(`/forecasts/crediti-imposta/${idCreditoImposta}`, { params: { ...forecast() } }),

  // Stati Patrimoniali
  getStatiPatrimoniali: idCompany => $axios.get(`/companies/${idCompany}/forecasts/stati-patrimoniali`, { params: { ...forecast() } }),
  addStatoPatrimoniale: (idCompany, statoPatrimoniale) => $axios.post(`/companies/${idCompany}/forecasts/stati-patrimoniali`, statoPatrimoniale, { params: { ...forecast() } }),
  getStatoPatrimoniale: (_, idStatoPatrimoniale) => $axios.get(`/forecasts/stati-patrimoniali/${idStatoPatrimoniale}`, { params: { ...forecast() } }),
  updateStatoPatrimoniale: (_, idStatoPatrimoniale, statoPatrimoniale) => $axios.put(`/forecasts/stati-patrimoniali/${idStatoPatrimoniale}`, statoPatrimoniale, { params: { ...forecast() } }),
  deleteStatoPatrimoniale: (_, idStatoPatrimoniale) => $axios.delete(`/forecasts/stati-patrimoniali/${idStatoPatrimoniale}`, { params: { ...forecast() } }),

  // Forecasts only computed
  getComputedDinamicaIva: idCompany => $axios.get(`/companies/${idCompany}/forecasts/computed/dinamica-iva`, { params: { ...forecast() } }),
  getComputedCreditoImposta: idCompany => $axios.get(`/companies/${idCompany}/forecasts/computed/credito-imposta`, { params: { ...forecast() } }),
  getComputedGestioneFiscale: idCompany => $axios.get(`/companies/${idCompany}/forecasts/computed/gestione-fiscale`, { params: { ...forecast() } }),

  // Balances
  getComputedStatoPatrimonialeFinanziario: idCompany => $axios.get(`/companies/${idCompany}/forecasts/computed/stato-patrimoniale-finanziario`, { params: { ...forecast() } }),
  getComputedStatoPatrimonialeFinanziarioMensile: idCompany => $axios.get(`/companies/${idCompany}/forecasts/computed/stato-patrimoniale-finanziario-mensile`, { params: { ...forecast() } }),
  getComputedAnalisiReddituale: idCompany => $axios.get(`/companies/${idCompany}/forecasts/computed/analisi-reddituale`, { params: { ...forecast() } }),
  getComputedAnalisiRedditualeMensile: idCompany => $axios.get(`/companies/${idCompany}/forecasts/computed/analisi-reddituale-mensile`, { params: { ...forecast() } }),
  getComputedCashFlow: idCompany => $axios.get(`/companies/${idCompany}/forecasts/computed/cash-flow`, { params: { ...forecast() } }),
  getComputedCashFlowMensile: idCompany => $axios.get(`/companies/${idCompany}/forecasts/computed/cash-flow-mensile`, { params: { ...forecast() } }),

  // Kpis
  getKpi: idCompany => $axios.get(`/companies/${idCompany}/forecasts/computed/kpi`, { params: { ...forecast() } }),

  // Crisi d'impresa
  getCrisiImpresa: idCompany => $axios.get(`/companies/${idCompany}/forecasts/computed/crisiImpresa`, { params: { ...forecast() } }),
};
